import { Store } from '@tanstack/react-store';

const ENV_FEATURE_FLAGS_KEY = 'VITE_FEATURE_FLAGS' as const;
const FEATURE_FLAG_DELIMITER = ',' as const;
const FEATURE_FLAG_VALUE_DELIMITER = ':' as const;

const featureFlags: string[] = import.meta.env[ENV_FEATURE_FLAGS_KEY]?.split(FEATURE_FLAG_DELIMITER) ?? [];
const featureFlagsMap = new Map<string, boolean>(featureFlags.map((flag) => {
    const [key, value] = flag.split(FEATURE_FLAG_VALUE_DELIMITER);
    return [key, value === 'true'];
}));

// Define the feature flags interface
export type FeatureFlags = {
    'prefetch-project-data': boolean;
    'offline-files': boolean;
};

export type FeatureFlag = keyof FeatureFlags;

// Default feature flags
const defaultFeatureFlags: FeatureFlags = {
    'prefetch-project-data': true,
    'offline-files': true,
};

// Create the feature flags store
export const featureFlagsStore = new Store<FeatureFlags>({
    ...defaultFeatureFlags,
    ...featureFlagsMap,
});

// Helper function to get the feature flag value

export type ToggleFeatureFlagOptions = {
    flag: FeatureFlag;
};

export function toggleFeatureFlag({ flag }: ToggleFeatureFlagOptions) {
    featureFlagsStore.setState(state => ({
        ...state,
        [flag]: !state[flag],
    }));
}

export type UpdateFeatureFlagOptions = {
    flag: FeatureFlag;
    value: boolean;
};

export function updateFeatureFlag({ flag, value }: UpdateFeatureFlagOptions) {
    featureFlagsStore.setState(state => ({
        ...state,
        [flag]: value,
    }));
}

export type ResetFeatureFlagOptions = {
    flag: FeatureFlag;
};

export function resetFeatureFlag({ flag }: ResetFeatureFlagOptions) {
    featureFlagsStore.setState(state => ({
        ...state,
        [flag]: defaultFeatureFlags[flag],
    }));
}
